import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { AhtDivertListComponent } from './aht-divert-list.component'

const AHT_DIVERT_LIST_ROUTES: Routes = [{
    path: '', component: AhtDivertListComponent
}];

export const AHT_DIVERT_LIST_ROUTING : ModuleWithProviders<any> = RouterModule.forChild(AHT_DIVERT_LIST_ROUTES);